import Edit from './PmcEdit'
import Main from './PmcMain'
import New from './PmcNew'
import Show from './PmcShow'

export default {
  Edit,
  Main,
  New,
  Show,
}
